<template>
  <div style="height:100%">
    <div id="cesiumContainer">
        <div class="toolbar">
            <span>高度：</span>
            <input type="number" v-model="heightValue" value="1" min="1" step="1" class="form-control" style="width:100px">（米）
            <input type="button" value="控高分析"  class="btn btn-primary" @click="height()">
        </div>
    </div>
     <div id="loadingOverlay"><h1>Loading........</h1></div>
  </div>
</template>
<script>
import util from "../../components/util"
export default {
    data () {
        return {
          viewer:null,
          heightValue:20,
          tileset:null
        }
    },
    mounted(){
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
       this.init()
    },
    methods: {
        init () {
            let viewer=util.getViewer('cesiumContainer',{
                homeButton: false,
                sceneModePicker: false,
                baseLayerPicker: false,
                infoBox: true,
            });

            let url="/demo/static/data/models/shp/tileset.json";
            // let url = "http://localhost:9000/model/f9548700f62511e9a13ca36c98e3e393/tileset.json";
            this.tileset = new Cesium.Cesium3DTileset({
                url: url
            });
            this.tileset.readyPromise.then(function(tileset) {
                viewer.scene.primitives.add(tileset);
                let heightStyle = new Cesium.Cesium3DTileStyle({
                    color : {
                        conditions: [

                            ['true', 'rgb(0, 255, 255)']

                        ]
                    }
                });
                tileset.style = heightStyle;
                viewer.zoomTo(tileset);
            }).otherwise(function(error) {
                console.log(error);
            });
        },
        height(){
            this.$message({
                showClose: true,
                message: '红色建筑物为超过高度建筑物，蓝色为正常建筑物。',
                duration: 10000
            });
            let height = Number(this.heightValue);

            let heightStyle = new Cesium.Cesium3DTileStyle({
                color : {
                    conditions: [
                        ['${height} >= ' + height, 'rgb(235, 61, 61)'],
                        ['true', 'rgb(0, 255, 255)']
                    ]
                }
            });
            this.tileset.style = heightStyle;
        }
    },
}
</script>
<style scoped>
#cesiumContainer{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
.toolbar{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 340px;
    height: 50px;
    top: 10px;
    left: 10px;
    padding: 10px 15px;
    border-radius: 4px;
    border: 1px solid rgba(128,128,128,.5);
    color: #fff;
    background: rgba(0,0,0,.4);
    box-shadow: 0 3px 14px rgba(128,128,128,.5);
    z-index: 100;
}
.form-control{
    color: #fff;
    background-color: rgba(63,72,84,.7);
    border: none;
}
.btn-primary{
    color:#fff;
    background-color: rgba(32,160,255,.2);
    cursor: pointer;
    margin: 0 2px 0 2px;
    border: 1px solid #e4eaec;
    border-radius: 3px;
}
</style>
